import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AppTextContext = createContext({ text: {}, t: (k) => k, refresh: () => {} });

export function AppTextProvider({ children }) {
  const [text, setText] = useState(null);

  const refresh = async () => {
    try {
      const { data } = await api.get("/app-text");
      setText(data);
    } catch {
      setText({});
    }
  };

  useEffect(() => { refresh(); }, []);

  // t("dashboard.greeting", { name: "Sulaiman" })
  const t = (path, vars = {}) => {
    if (!text) return "";
    const parts = path.split(".");
    let cur = text;
    for (const p of parts) {
      if (cur && typeof cur === "object" && p in cur) cur = cur[p];
      else return path; // fallback to key path
    }
    if (typeof cur !== "string") return path;
    return cur.replace(/\{(\w+)\}/g, (_, k) => (k in vars ? String(vars[k]) : ""));
  };

  return (
    <AppTextContext.Provider value={{ text: text || {}, t, refresh, loaded: !!text }}>
      {children}
    </AppTextContext.Provider>
  );
}

export const useAppText = () => useContext(AppTextContext);
